import SEO from '../components/SEO';
import DeveloperToolsPanel from '../components/DeveloperToolsPanel';

export default function YAMLConverterPage() {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "YAML to JSON Converter - JsonToonCraft",
    "applicationCategory": "DeveloperApplication",
    "operatingSystem": "Web",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD"
    },
    "description": "Free YAML to JSON converter and JSON to YAML converter. Bidirectional conversion between YAML and JSON formats.",
    "featureList": [
      "YAML to JSON conversion",
      "JSON to YAML conversion",
      "Bidirectional conversion",
      "Config file conversion",
      "Instant conversion",
      "Copy to clipboard"
    ]
  };

  return (
    <>
      <SEO
        title="YAML to JSON Converter - Convert YAML and JSON Online | JsonToonCraft"
        description="Free YAML to JSON converter and JSON to YAML converter. Bidirectional conversion between YAML and JSON formats. Perfect for config files."
        keywords="YAML to JSON, JSON to YAML, YAML converter, JSON converter, convert YAML, convert JSON, config converter"
        canonicalUrl="https://jsontooncraft.com/dev-tools/yaml-converter"
        structuredData={structuredData}
      />

      <DeveloperToolsPanel initialTool="yaml" />
    </>
  );
}
